// ============================================================================
// INSERTION SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'insertion-sort',
  name: 'Insertion Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n²) average/worst, O(n) best',
    space: 'O(1)'
  },
  description: 'A simple sorting algorithm that builds the final sorted array one item at a time. It iterates through the input and inserts each element into its correct position in the already-sorted portion of the array.'
};
